<template>
    <div class="committee-members-list">
        <!-- Empty State -->
        <div
            v-if="!modelValue || modelValue.length === 0"
            class="congress-schedule-after-event-list-actions empty-state-inline"
        >
            <Button type="button" size="sm" color="brand" variant="inline" @click="addMember">
                <span class="action-icon">
                    <Icon icon="phosphor/regular/user-plus"></Icon>
                </span>
                <span class="action-label-text">
                    {{ lang('congresses::congresses.committee_members.add_first') }}
                </span>
            </Button>
        </div>

        <!-- Members List -->
        <template v-else>
            <Sortable :list="modelValue" item-key="_id" tag="div" @end="onReordered">
                <template #item="{ element: member, index }">
                    <div :key="`${member._id}-${index}`" class="tree-line-item grid grid-cols-12">
                        <div class="col-span-1">
                            <TreeLine />
                        </div>
                        <div class="col-span-11">
                            <CommitteeMemberCard
                                :key="member._id"
                                v-model="modelValue[index]"
                                :index="index"
                                :committee-index="committeeIndex"
                                @remove="removeMember(index)"
                            />
                        </div>
                    </div>
                </template>
            </Sortable>

            <!-- Add Button -->
            <div class="congress-schedule-after-event-list-actions">
                <Button type="button" size="sm" color="brand" variant="inline" @click="addMember">
                    <span class="action-icon">
                        <Icon icon="phosphor/regular/user-plus"></Icon>
                    </span>
                    <span class="action-label-text">
                        {{ lang('congresses::congresses.committee_members.add') }}
                    </span>
                </Button>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import { v4 as uuidv4 } from 'uuid';
import { lang } from '@/lang/composable';
import Sortable from '@src/Common/Components/Sortable.vue';
import Button from '@src/Common/Components/Button.vue';
import TreeLine from '@src/Common/Components/TreeLine.vue';
import CommitteeMemberCard from './CommitteeMemberCard.vue';
import type { CommitteeMember } from '../types';

defineProps<{
    committeeIndex: number;
}>();

const modelValue = defineModel<CommitteeMember[]>();

const addMember = () => {
    if (!modelValue.value) {
        modelValue.value = [];
    }
    modelValue.value = [
        ...modelValue.value,
        {
            _id: uuidv4(),
            name: '',
            role: '',
            email: '',
            phone: '',
            bio: '',
            avatar_media_id: null,
            color: '',
            display_style: null,
            sort_order: modelValue.value.length,
        },
    ];
};

const removeMember = (index: number) => {
    if (confirm(lang('congresses::congresses.committee_members.confirm_remove'))) {
        modelValue.value = modelValue.value.filter((_, idx) => idx !== index);
    }
};

const onReordered = (event: { oldIndex: number; newIndex: number }) => {
    const items = [...modelValue.value];
    const [movedItem] = items.splice(event.oldIndex, 1);
    items.splice(event.newIndex, 0, movedItem);

    items.forEach((member, idx) => {
        member.sort_order = idx;
    });

    modelValue.value = items;
};
</script>
